<template>
    <el-dialog title="添加奖项设置" :visible.sync="dialogAwardVisible"
               :close-on-click-modal="false"
               append-to-body class="dialogAwardVisible">
        <el-form :model="trackAward" :rules="rulesSuccess" ref="ruleForm">
            <el-form-item label="奖项名称"  prop="awardName">
                <el-input v-model="trackAward.awardName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="奖项人数">
                <el-input v-model="trackAward.awardNumber" @input="input" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="奖品名称"  prop="awardContent">
                <el-input v-model="trackAward.awardContent" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="奖项配图"  prop="awardUrl">
                <div style="display: flex;"  v-loading="thumbnailLoading3" class="awaedUrlImgs">
                    <el-upload
                        action="/service-center/upload/file/single"
                        :show-file-list="false"
                        :headers="headers"
                        :on-success="handleAvatarSuccessUrl"
                        :before-upload="beforeAvatarUploadUrl" class="thumbnailClass">
                        <div class="avatar" v-if="!trackAward.awardUrl">
                            <i class="el-icon-plus"></i>
                        </div>
                        <div>
                            <el-image
                                v-if="trackAward.awardUrl"
                                :src="trackAward.awardUrl"
                                class="thumbnailClass"
                                style="border: solid 1px #ececec;background-color: #f9f9f9;"
                                :preview-src-list="thumbnailListForm">
                            </el-image>
                        </div>
                        <p class="imgsMess">请上传 120 * 154 的图片</p>
                    </el-upload>
                </div>
            </el-form-item>
            <el-form-item prop="sort" label="排序">
                <el-input-number v-model="trackAward.sort"  :min="1"></el-input-number>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogAwardVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitTrackAwardInfo">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "trackAwardDialog",
    data() {
        return {
            headers: {
                'Authorization': 'Bearer ' + window.sessionStorage.getItem("api_access_token")
            },
            thumbnailListForm:[],
            thumbnailLoading3: false,
            dialogAwardVisible:false,
            trackAward: {
                awardName: '',
                awardNumber: '0',
                awardContent: '',
                awardUrl: '',
                sort:1,
                updateIndex:'',
            },
            rulesSuccess:{
                awardName:[
                    {required: true, message: '请输入奖项名称', trigger: 'blur'}
                ],
                // awardNumber:[
                //     {required: true, message: '请输入奖项人数', trigger: 'blur'}
                // ],
                awardContent:[
                    {required: true, message: '请输入奖品名称', trigger: 'blur'}
                ],
                awardUrl:[
                    {required: true, message: '请上传奖项配图', trigger: 'blur'}
                ],
                sort:[
                    {required: true, message: '请设置排序', trigger: 'blur'}
                ],
            },
        }
    },
    created(){

    },
    methods: {
        input(){
            this.trackAward.awardNumber = this.trackAward.awardNumber.replace(/[^\d]/g,'');
        },
        init(item){
            this.reset();
            if(item!==undefined&&item!==null){
                this.trackAward = item;
            }
            this.dialogAwardVisible = true;
        },
        reset(){
            // 置空
            this.trackAward = {
                awardName: '',
                awardNumber: '',
                awardContent: '',
                awardUrl: '',
                sort:1,
            };
            this.$nextTick(() => {
                // DOM 更新了
                this.$refs["ruleForm"].clearValidate()
            });
        },
        submitTrackAwardInfo(){
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    // 保存数据
                    this.dialogAwardVisible = false;
                    this.$emit("submit",this.trackAward);
                }
            });

        },
        // 奖项配图
        handleAvatarSuccessUrl(res, file) {
            this.trackAward.awardUrl = res.url;
            this.thumbnailLoading3 = false;
            this.$refs.ruleForm.validateField('img')
        },
        beforeAvatarUploadUrl(file) {
            this.thumbnailLoading3 = true;
            const isJPG = file.type.indexOf('image') !== -1;
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.warning('上传图片只能是图片格式!');
                this.thumbnailLoading3 = false;
            }
            if (!isLt2M) {
                this.$message.warning('上传图片大小不能超过 2MB!');
                this.thumbnailLoading3 = false;
            }
            return isJPG && isLt2M;
        },
    },
}
</script>

<style  scoped lang="less">
.imgsMess {
    margin: 0;
    margin-left: 10px;
    color: #a1a1a1;
}
.thumbnailClass{
    width: 222px;
    //height: 125px;
    .avatar{
        width: 222px;
        height: 125px;
        border: 1px dashed #ddd;
        border-radius: 4px;
        line-height: 125px;
        font-size: 50px;
    }
}
.modelHeightRangeClass{
    display: flex;
    margin-bottom: 25px;
    /deep/.el-form-item__content{
        margin-left: 0 !important;
    }
}
.dialogAwardVisible {
    /deeep/.el-dialog__body {
        padding-left: 30px !important;
        padding-right: 30px !important;
    }
}
.awaedUrlImgs {
    /deep/.el-image {
        width: 125px;
        height: 154px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/trackAwardDialog.vue